const account = {
    title: String("Perfil de usuario"),

    terrains:   String("Fincas"),
    modules:    String("Estaciones"),
    myDataTitle:    String("Mi perfil de usuario"),
    aboutMeTitle:   String("Sobre mi"),

    usernameLabel:  String("Nombre de usuario"),
    nifLabel:   String("DNI/NIF"),
    nifPlaceholder: String("12345678a"),
    emailLabel: String("Correo electrónico"),
    emailPlaceholder: String("Example&#64example.com"),
    nameLabel:  String("Nombre"),
    namePlaceholder:    String("Nombre..."),
    lastName1Label: String("Primer apellido"),
    lastName1Placeholder:   String("Primer apellido..."),
    lastName2Label: String("Segundo apellido"),
    lastName2Placeholder:   String("Segundo apellido..."),
    phoneLabel: String("Teléfono"),
    phonePlaceholder:   String("123456789"),
    selectLanguage:   String("Selecciona el idioma"),
    
    contactInfoTitle:   String("Información de contacto"),
    addressSearchBarLabel:  String("Buscar dirección"),
    accountGoogleAskAddressPlaceholder: String("Calle de Ejemplo"),
    addressLabel:   String("Dirección"),
    addressPlaceholder: String("Calle de Ejemplo"),
    numberLabel:    String("Número"),
    numberPlaceholder:  String("0"),
    cityLabel:  String("Ciudad"),
    cityPlaceholder:    String("Ciudad..."),
    provinceLabel:  String("Provincia"),
    provincePlaceholder:    String("Provincia..."),
    zipLabel:   String("Código Postal"),
    zipPlaceholder: String("12345"),
    regionLabel:    String("Región"),
    regionPlaceholder:  String("Región..."),
    countryLabel:   String("País"),
    countryPlaceholder: String("País..."),
    
    updateButton:   String("Actualizar"),
    restoreButton:  String("Restaurar"),
    
    errorFieldRequired: String("Este campo es obligatorio"),
    errorFieldEmail: String("Dirección de correo invalida."),
    errorInvalidField: String("Campo invalido. Este campo solo puede contener letras, guiones (-) y espacios."),
    errorInvalidNif: String("Formato invalido. Este campo debe contener 8 números mas una letra. 01234567A"),
    errorFieldNumeric: String("Este campo solo puede contener números"),
    errorInvalidLength: String("Número de caracteres mínimo: {length}"),

    errorsModalTitle:   String("Error en actualización"),
    errorsModalBodyTitle:   String("Ha habido algun error durante la actualización:"),
    errorsModalCloseButton: String("Cerrar"),

};

export default account;
